module.exports = __webpack_public_path__ + "media/images/riders/GUNN-RITA_DAHLE_FLESJA-154284d4500b9275dad29c7ec0352556.png";